export default "__VITE_ASSET__G0yy1edT__"